import React, { useCallback, useEffect, useState } from 'react'
import "./footer.scss"
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// import Messegeboxblue from '../../../admin/common/icons/sidebar/Messegeboxblue';
import DownArrow from '../assets/icons/DownArrow';
import Globe from '../assets/icons/Globe';
import { _Api } from 'Ecommerce/common/api';
const Footer = (props) => {
    const { websiteinfo} = props;
    const { t } = useTranslation();
    const {i18n} = useTranslation();
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    let langdata = JSON.parse(localStorage.getItem('UserLangecom'));

    const [languageDropdown, setLanguageDrodown] = useState(false);
    const [LanguageList, setLanguageData] = useState(null);
    const [CurrentLan_flg, setLanguageSelectData] = useState({ Lan_photo: 'US.png', lang: "english", label: "English (US)" })
    const [checkApiCall, setCheckApiCall] = useState(true);
const [currencyDropdown , setCurrencyDropdown] = useState(false);
    useEffect(()=>{
        languagedata()
    },[])

    const languagedata = async () => {
        setCheckApiCall(false)
        try {
            let postdata = {};
            let res = await _Api(postdata, `language`);
            if (res?.statusCode === 200) {
                setLanguageData(res?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };

    const rtlView = useCallback((type, l) => {
        var jsonData = JSON.stringify(l);
        localStorage.setItem("UserLangecom", jsonData);
        setLanguageSelectData(l)
        let bodyid = document.querySelector("#body_id");
        if (type === "rtl") {
            bodyid.classList.add("rtl");
        } else {
            bodyid.classList.remove("rtl");
        }
    }, [setLanguageSelectData]);
    useEffect(() => {
        if (langdata) {
            setLanguageSelectData(langdata)
        } else {
            setLanguageSelectData({ Lan_photo: 'US.png', lang: "english",  Label: "English (US)" })
        }

        if (langdata?.Lan_photo === 'SA.png') {
            rtlView('rtl', langdata)
        }
        // eslint-disable-next-line
    }, [checkApiCall, setLanguageSelectData, rtlView])

    return (
        <div className='ecommerce-footer'>
            <div className='ecommerce-footer-inner'>
                <div className='ecommerce-footer-inner-content'>
                    <div className='ecommerce-footer-inner-content-block'>
                        <div className='ecommerce-footer-inner-content-block-logo'>
                        <Link to="/">
                        <img src={websiteinfo?.websiteInfo?.logo} alt="" />
                        </Link> 
                        </div>
                    </div>
                    <div className='ecommerce-footer-inner-content-block'>
                        <div className='ecommerce-footer-inner-content-block-title'>{t("Explore")}</div>
                        <div className='ecommerce-footer-inner-content-block-data'>
                            <Link to="/">{t("Categories")}</Link>
                            <Link to="/Collection">{t("Collections")}</Link>
                            <Link to="/appointment">{t("Book an Appointment")}</Link>
                            <Link to="/contactus">{t("Contact us")}</Link>
                        </div>
                    </div>
                    <div className='ecommerce-footer-inner-content-block'>
                    <div className='ecommerce-footer-inner-content-block-title'>{t("Wishlist")}</div>
                        <div className='ecommerce-footer-inner-content-block-data'>
                            <Link to="/wishlist">{t("My wishlist")}</Link>
                        </div>
                    </div>
                    <div className='ecommerce-footer-inner-content-block'>
                    <div className='ecommerce-footer-inner-content-block-title'>{t("Account")}</div>
                        <div className='ecommerce-footer-inner-content-block-data'>
                            <Link to="/account">{t("My Account")}</Link>
                        </div>
                    </div>
                </div>
                <div className='ecommerce-footer-inner-bottom'>
                   <div style={{flexWrap:'wrap',justifyContent:'left'}} className='ecommerce-footer-inner-bottom-policy'>
                          {/* <span><Link to="/page/privacy-policy">{t("Privacy policy")}</Link></span>
                    <span><Link to="/page/terms-service">&bull;{t(" Terms of service")}</Link></span>
                    <span><Link to="/page/refunds-and-returns-policy">&bull;{t(" Refunds and Return Policy")}</Link></span>
                    <span><Link to="/page/size-guidence">&bull;{t(" Size guidence")}</Link></span> */}
                    
                    { websiteinfo?.Pages?.length > 0 ? websiteinfo?.Pages?.map((page, index) => (
        <span key={page._id}>
          {index > 0 && " • "}
          <Link to={`/page/${page?.slug}`}>{page?.title}</Link>
        </span>
      )) : null}
                    </div>
                        <div className='ecommerce-footer-inner-bottom-controls position-relative'>
                         <div className='ecommerce-footer-inner-bottom-controls-socials'>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.facebook ? '' : 'none'}`}}  >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.facebook ? websiteinfo?.websiteInfo?.socialLink?.facebook : '' }`} target='_blank'>
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.99999 0C13.9705 0 18 4.02944 18 8.99999C18 13.6014 14.5466 17.3958 10.0904 17.9341V11.7502L12.525 11.7502L13.0301 9H10.0904V8.02731C10.0904 7.30063 10.2329 6.79754 10.5599 6.47612C10.8869 6.1547 11.3984 6.01495 12.1363 6.01495C12.323 6.01495 12.4949 6.01681 12.6475 6.02052C12.8693 6.02592 13.0501 6.03525 13.176 6.0485V3.55536C13.1257 3.54138 13.0663 3.5274 12.9998 3.51365C12.849 3.48248 12.6617 3.45243 12.4602 3.42605C12.0393 3.3709 11.557 3.33173 11.2195 3.33173C9.8568 3.33173 8.82691 3.62327 8.10802 4.22714C7.24041 4.95593 6.82581 6.13966 6.82581 7.81491V8.99999H4.96994V11.7502H6.82581V17.735C2.90574 16.7624 0 13.2208 0 8.99999C0 4.02944 4.02944 0 8.99999 0Z" fill="#767676"/>
                                                        </svg>
                                                        </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.instagram ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.instagram ? websiteinfo?.websiteInfo?.socialLink?.instagram : '' }`} target='_blank'>
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.7964 5.26659C13.2004 5.26776 12.7157 4.78515 12.7146 4.18911C12.7134 3.59307 13.196 3.10843 13.7923 3.10726C14.3886 3.1061 14.8733 3.58899 14.8744 4.18503C14.8753 4.78107 14.3927 5.26543 13.7964 5.26659Z" fill="#767676"/>
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M9.00861 13.6208C6.45682 13.6257 4.38383 11.5612 4.37888 9.00874C4.37391 6.45692 6.43902 4.38361 8.99082 4.37865C11.5432 4.37369 13.6165 6.43942 13.6214 8.99096C13.6264 11.5434 11.5607 13.6158 9.00861 13.6208ZM8.99403 6.00026C7.33774 6.00318 5.99696 7.34893 5.99987 9.00554C6.00308 10.6624 7.34911 12.0029 9.0054 11.9997C10.6623 11.9965 12.0031 10.6511 11.9998 8.99417C11.9966 7.33727 10.6506 5.99706 8.99403 6.00026Z" fill="#767676"/>
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.0894 0.484859C3.66095 0.260907 4.315 0.107522 5.27262 0.0623237C6.23258 0.0162545 6.53904 0.00575327 8.98265 0.00108947C11.4269 -0.00357433 11.7333 0.00575146 12.6933 0.0483251C13.6512 0.0897323 14.3055 0.240786 14.8782 0.462408C15.4708 0.690731 15.9735 0.998086 16.4745 1.49702C16.9754 1.99654 17.2839 2.49752 17.5152 3.08918C17.7388 3.66131 17.8922 4.31479 17.9377 5.27301C17.9832 6.23267 17.9943 6.53885 17.9989 8.98279C18.0036 11.4264 17.9937 11.7332 17.9517 12.6938C17.91 13.6511 17.7593 14.3057 17.5376 14.8782C17.3087 15.4707 17.002 15.9734 16.503 16.4744C16.0041 16.9757 15.5026 17.2839 14.9109 17.5154C14.3388 17.7388 13.6853 17.8922 12.7277 17.938C11.7677 17.9834 11.4613 17.9942 9.01677 17.9989C6.57344 18.0036 6.26698 17.9942 5.30704 17.952C4.34912 17.91 3.69448 17.7592 3.12206 17.5379C2.52954 17.3087 2.02682 17.0022 1.52584 16.503C1.02458 16.0037 0.715789 15.5025 0.484844 14.9108C0.260893 14.339 0.10808 13.6852 0.0623045 12.7279C0.0165269 11.7676 0.0057413 11.4609 0.0010793 9.0172C-0.0036007 6.57327 0.0060275 6.26709 0.0480125 5.30712C0.0902999 4.34891 0.240478 3.69455 0.462097 3.12154C0.690996 2.52929 0.997759 2.02686 1.49728 1.5256C1.9962 1.02462 2.49775 0.715513 3.0894 0.484859ZM3.70615 16.0259C4.0237 16.1481 4.50017 16.2939 5.37761 16.3321C6.32705 16.3732 6.61135 16.3823 9.01385 16.3776C11.4172 16.3732 11.7015 16.363 12.6507 16.3184C13.5273 16.2767 14.0037 16.1291 14.3204 16.0055C14.7406 15.8413 15.0398 15.6451 15.3541 15.3304C15.6685 15.0146 15.863 14.7146 16.0257 14.2944C16.1481 13.9765 16.2937 13.4997 16.3319 12.6223C16.3736 11.6734 16.3823 11.3888 16.3776 8.98571C16.3733 6.58318 16.3631 6.29858 16.3179 5.3494C16.2765 4.47254 16.1292 3.99606 16.0053 3.67967C15.8411 3.25889 15.6454 2.96029 15.3299 2.64565C15.0144 2.331 14.7144 2.13708 14.2936 1.97437C13.9766 1.85161 13.4995 1.70639 12.6227 1.66819C11.6732 1.62649 11.3886 1.61803 8.98557 1.6227C6.58307 1.62736 6.29877 1.63698 5.34961 1.6819C4.47247 1.72359 3.99658 1.87085 3.67931 1.99479C3.25941 2.15896 2.96022 2.35404 2.64559 2.66985C2.33153 2.98565 2.13703 3.28513 1.97433 3.70621C1.85245 4.02348 1.70576 4.50054 1.66815 5.3774C1.62673 6.32686 1.618 6.61147 1.62266 9.01399C1.62704 11.4171 1.63724 11.7017 1.68186 12.6503C1.72297 13.5277 1.87139 14.0036 1.99474 14.3212C2.15891 14.7408 2.35458 15.04 2.6698 15.3546C2.98561 15.6681 3.28566 15.8632 3.70615 16.0259Z" fill="#767676"/>
                                                        </svg> </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.pinterest ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.pinterest ? websiteinfo?.websiteInfo?.socialLink?.pinterest : '' }`} target='_blank'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#767676" width="48px" height="48px">
                                                        <path d="M12 2.04C6.51 2.04 2 6.51 2 12c0 4.16 2.96 7.67 6.94 8.77-.09-.75-.17-1.9.04-2.72.18-.77 1.2-5.21 1.2-5.21s-.3-.6-.3-1.48c0-1.39.8-2.43 1.8-2.43.85 0 1.27.63 1.27 1.39 0 .85-.54 2.12-.81 3.3-.23.98.48 1.79 1.42 1.79 1.7 0 2.99-1.8 2.99-4.39 0-2.29-1.65-3.89-4.01-3.89-2.73 0-4.34 2.05-4.34 4.18 0 .83.32 1.72.73 2.2a.3.3 0 0 1 .07.29c-.08.33-.27 1.11-.31 1.26-.05.22-.18.27-.42.16-1.56-.73-2.52-3.03-2.52-4.88 0-3.97 2.88-7.62 8.31-7.62 4.35 0 7.73 3.1 7.73 7.26 0 4.31-2.72 7.79-6.5 7.79-1.27 0-2.46-.68-2.86-1.48l-.78 2.96c-.28 1.06-1.04 2.39-1.56 3.2a9.94 9.94 0 0 0 3.14.48c5.49 0 9.98-4.47 9.98-9.97 0-5.5-4.49-9.96-9.98-9.96z"/>
                                                        </svg>
                        
                                                        </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.whatsapp ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.whatsapp ? websiteinfo?.websiteInfo?.socialLink?.whatsapp : '' }`} target='_blank'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="#767676">
                                                        <path d="M20.52 3.48A11.834 11.834 0 0 0 12 0C5.373 0 0 5.373 0 12a11.864 11.864 0 0 0 1.822 6.355L.049 24l5.775-1.52A11.937 11.937 0 0 0 12 24c6.627 0 12-5.373 12-12 0-3.193-1.253-6.204-3.48-8.52zM12 22.152a10.13 10.13 0 0 1-5.3-1.47l-.379-.227-3.431.904.916-3.347-.246-.384A10.122 10.122 0 0 1 1.848 12c0-5.617 4.571-10.152 10.152-10.152 2.715 0 5.261 1.055 7.177 2.973A10.1 10.1 0 0 1 22.152 12c0 5.617-4.571 10.152-10.152 10.152zm5.55-7.877c-.3-.15-1.779-.88-2.057-.982-.278-.101-.48-.15-.682.15s-.782.981-.961 1.179c-.18.199-.361.225-.661.075-.3-.15-1.263-.466-2.406-1.485-.888-.789-1.487-1.764-1.661-2.064-.174-.301-.019-.463.13-.612.134-.134.3-.349.45-.524a2.18 2.18 0 0 0 .3-.524c.101-.199.05-.374-.025-.524-.075-.15-.682-1.64-.934-2.25-.246-.593-.497-.512-.682-.512h-.582c-.2 0-.524.075-.8.374s-1.05 1.027-1.05 2.5 1.075 2.875 1.225 3.075c.15.199 2.11 3.225 5.118 4.523.716.309 1.275.494 1.71.632.719.229 1.374.197 1.893.12.578-.086 1.779-.725 2.03-1.425.25-.7.25-1.3.175-1.424-.075-.124-.275-.199-.575-.349z" />
                                                        </svg>
                        
                                                        </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.youtube ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.youtube ? websiteinfo?.websiteInfo?.socialLink?.youtube : '' }`} target='_blank'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="#767676">
                          <path d="M23.499 6.186a2.97 2.97 0 0 0-2.096-2.102C19.771 3.452 12 3.452 12 3.452s-7.771 0-9.403.632a2.97 2.97 0 0 0-2.096 2.102C0 7.818 0 12.003 0 12.003s0 4.186.501 5.816a2.97 2.97 0 0 0 2.096 2.102c1.632.632 9.403.632 9.403.632s7.771 0 9.403-.632a2.97 2.97 0 0 0 2.096-2.102c.501-1.63.501-5.816.501-5.816s0-4.185-.501-5.817zM9.75 15.568v-7.13l6.364 3.568-6.364 3.562z" />
                        </svg>
                        
                                                         </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.twitter ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.twitter ? websiteinfo?.websiteInfo?.socialLink?.twitter : '' }`} target='_blank'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="#767676">
                          <path d="M23.954 4.569a10 10 0 0 1-2.825.775 4.994 4.994 0 0 0 2.163-2.723 9.936 9.936 0 0 1-3.127 1.195 4.932 4.932 0 0 0-8.395 4.49A14.005 14.005 0 0 1 1.671 3.149a4.916 4.916 0 0 0-.666 2.475c0 1.71.87 3.223 2.188 4.103a4.908 4.908 0 0 1-2.231-.616c-.053 2.28 1.582 4.415 3.946 4.89a4.996 4.996 0 0 1-2.224.085c.63 1.952 2.445 3.376 4.604 3.414a9.885 9.885 0 0 1-6.29 2.159c-.41 0-.816-.024-1.214-.071a14.013 14.013 0 0 0 7.548 2.212c9.142 0 14.307-7.721 14.307-14.414 0-.22-.005-.437-.015-.653a10.22 10.22 0 0 0 2.489-2.605z" />
                        </svg>
                        
                                                         </Link>
                                                    </span>
                                                    <span style={{display:`${websiteinfo?.websiteInfo?.socialLink?.linkedin ? '' : 'none'}`}} >
                                                        <Link to={`${websiteinfo?.websiteInfo?.socialLink?.linkedin ? websiteinfo?.websiteInfo?.socialLink?.linkedin : '' }`} target='_blank'>
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clipPath="url(#clip0_3379_4542)">
                                                        <path d="M16.6676 0H1.32891C0.594141 0 0 0.580078 0 1.29727V16.6992C0 17.4164 0.594141 18 1.32891 18H16.6676C17.4023 18 18 17.4164 18 16.7027V1.29727C18 0.580078 17.4023 0 16.6676 0ZM5.34023 15.3387H2.66836V6.74648H5.34023V15.3387ZM4.0043 5.57578C3.14648 5.57578 2.45391 4.8832 2.45391 4.02891C2.45391 3.17461 3.14648 2.48203 4.0043 2.48203C4.85859 2.48203 5.55117 3.17461 5.55117 4.02891C5.55117 4.87969 4.85859 5.57578 4.0043 5.57578ZM15.3387 15.3387H12.6703V11.1621C12.6703 10.1672 12.6527 8.88398 11.2816 8.88398C9.89297 8.88398 9.68203 9.97031 9.68203 11.0918V15.3387H7.01719V6.74648H9.57656V7.9207H9.61172C9.9668 7.2457 10.8387 6.53203 12.1359 6.53203C14.8395 6.53203 15.3387 8.31094 15.3387 10.6242V15.3387Z" fill="#767676"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_3379_4542">
                                                        <rect width="18" height="18" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                     </Link>
                                                    </span>
                                                </div>
                        {/* <div className='ecommerce-footer-inner-bottom-controls-lang' 
                            id="languagedropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded={!languageDropdown}
                            onClick={() => setLanguageDrodown(!languageDropdown)}>
                                <Globe/>
                                <span style={{textWrap:'nowrap'}}>{t("English (US)")}</span>
                                <span className={`icon-holder ${languageDropdown ? 'active' : ''}`}>
                                   <DownArrow height="5" width="10" color="#767676"/>
                                </span>
                                {languageDropdown ? 
                        <ul
                            className="dropdown-menu dropdown-menu-end flex-column tempfourlang"
                            aria-labelledby="languagedropdown"
                        >
                            {LanguageList?.map((LanguageCode, key) => (
                                <li key={key}>
                                    {LanguageCode.Lan_value === "arabic" ? (
                                        <Link
                                            className="dropdown-item"
                                            onClick={() => {
                                                i18n.changeLanguage(LanguageCode.Lan_value);
                                                rtlView("rtl", {
                                                    Lan_photo: LanguageCode?.Lan_photo,
                                                    lang: LanguageCode?.Lan_value
                                                });
                                                setLanguageDrodown(false);
                                            }}
                                            data-bs-toggle="collapse"
                                            data-bs-target="#navbarSupportedContent"
                                        >
                                            <img
                                                src={
                                                    base_assets +
                                                    "images/flags/" +
                                                    LanguageCode.Lan_photo
                                                }
                                                alt=""
                                            />{" "}
                                            <span>{LanguageCode.Lan_text}</span>
                                        </Link>
                                    ) : (
                                        <Link
                                            className="dropdown-item"
                                            onClick={() => {
                                                i18n.changeLanguage(LanguageCode.Lan_value);
                                                rtlView("ltr",
                                                    {
                                                        Lan_photo: LanguageCode?.Lan_photo,
                                                        lang: LanguageCode?.Lan_value
                                                    });
                                                    setLanguageDrodown(false);
                                            }}
                                            data-bs-toggle="collapse"
                                            data-bs-target="#navbarSupportedContent"
                                        >
                                            <img
                                                style={{
                                                    width: "25px",
                                                    height: "100%",
                                                }}
                                                src={
                                                    base_assets +
                                                    "images/flags/" +
                                                    LanguageCode.Lan_photo
                                                }
                                                alt=""
                                            />{" "}
                                            <span>{LanguageCode.Lan_text}</span>
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                        :null}
                        </div> */}

                        <div
                            className='ecommerce-footer-inner-bottom-controls-lang' 
                            id="languagedropdown"
                            aria-expanded={languageDropdown}
                            onClick={() => setLanguageDrodown(!languageDropdown)}
                        >
                            <Globe/>
                            <span style={{ whiteSpace: 'nowrap' }}>{CurrentLan_flg?.label}</span>
                            <span className={`icon-holder ${languageDropdown ? 'active' : ''}`}>
                                <DownArrow height="5" width="10" color="#767676"/>
                            </span>

                            {languageDropdown && (
                                <ul
                                    className="dropdown-menu dropdown-menu-end flex-column tempfourlang"
                                    aria-labelledby="languagedropdown"
                                >
                                    {LanguageList?.map((LanguageCode, key) => (
                                        <li key={key}>
                                            {LanguageCode.Lan_value === "arabic" ? (
                                                <Link
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                        i18n.changeLanguage(LanguageCode.Lan_value);
                                                        rtlView("rtl", {
                                                            Lan_photo: LanguageCode?.Lan_photo,
                                                            lang: LanguageCode?.Lan_value,
                                                            label: LanguageCode?.Lan_text
                                                        });
                                                        setLanguageDrodown(false);
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            base_assets +
                                                            "images/flags/" +
                                                            LanguageCode.Lan_photo
                                                        }
                                                        alt=""
                                                    />{" "}
                                                    <span>{LanguageCode.Lan_text}</span>
                                                </Link>
                                            ) : (
                                                <Link
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                        i18n.changeLanguage(LanguageCode.Lan_value);
                                                        rtlView("ltr", {
                                                            Lan_photo: LanguageCode?.Lan_photo,
                                                            lang: LanguageCode?.Lan_value,
                                                            label: LanguageCode?.Lan_text
                                                        });
                                                        setLanguageDrodown(false);
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            width: "25px",
                                                            height: "100%",
                                                        }}
                                                        src={
                                                            base_assets +
                                                            "images/flags/" +
                                                            LanguageCode.Lan_photo
                                                        }
                                                        alt=""
                                                    />{" "}
                                                    <span>{LanguageCode.Lan_text}</span>
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        
                        {/* <div className='ecommerce-footer-inner-bottom-controls-country'
                                id="currencyDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded={!currencyDropdown}
                                onClick={() => setCurrencyDropdown(!currencyDropdown)}
                            >
                                <span style={{whiteSpace:'nowrap'}}>{websiteinfo?.currency ? websiteinfo?.currency : 'Currency'}</span>
                                <span className={`icon-holder ${currencyDropdown ? 'active' : ''}`}>
                                        <DownArrow height="5" width="10" color="#767676"/>    
                                </span>
                                {currencyDropdown ? 
                            <ul
                                className="dropdown-menu dropdown-menu-end flex-column tempfourcurrency"
                                aria-labelledby="currencyDropdown"
                            >
                                {websiteinfo?.currency ? 
                                    <li >
                                        
                                            <Link
                                                className="dropdown-item"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#navbarSupportedContent"
                                            >
                                                
                                                <span>{websiteinfo?.currency ? websiteinfo?.currency : 'Not available'} </span>
                                            </Link>
                                        
                                    </li> : null
                                }
                            </ul>
                            :null}
                            </div> */}

                    <div
                        className='ecommerce-footer-inner-bottom-controls-country'
                        id="currencyDropdown"
                        aria-expanded={currencyDropdown}
                        onClick={() => setCurrencyDropdown(!currencyDropdown)}
                    >
                        <span style={{ whiteSpace: 'nowrap' }}>
                            {websiteinfo?.currency ? websiteinfo?.currency : 'Currency'}
                        </span>
                        <span className={`icon-holder ${currencyDropdown ? 'active' : ''}`}>
                            <DownArrow height="5" width="10" color="#767676" />
                        </span>

                        {currencyDropdown && (
                            <ul
                                className="dropdown-menu dropdown-menu-end flex-column tempfourcurrency"
                                aria-labelledby="currencyDropdown"
                            >
                                {websiteinfo?.currency ? (
                                    <li>
                                        <Link className="dropdown-item">
                                            <span>{websiteinfo?.currency}</span>
                                        </Link>
                                    </li>
                                ) : null}
                            </ul>
                        )}
                    </div>

                            
                    </div>
                    
                </div>
                </div>
               {websiteinfo?.websiteInfo?.footerText ? <div className='footer-text-div'> <span>{t(websiteinfo?.websiteInfo?.footerText)}</span></div> : null}
               {/* <ul>
                    <li className='ecommerce-footer-inner-singleList'>
                        <span className='ecommerce-footer-inner-singleList-dotBox'></span>{t("Privacy policy")}</li>
                    <li className='ecommerce-footer-inner-singleList'><span className='ecommerce-footer-inner-singleList-dotBox'></span>{t("Terms of service")}</li>
                </ul> */}
            </div>
    )
}

export default Footer